// extracted by mini-css-extract-plugin
export default {"root":"lightbox-module--root--lF--R","header":"lightbox-module--header--GFRTD","closeBtn":"lightbox-module--closeBtn--2oAXk","body":"lightbox-module--body--o+LDs"};